'use client';

import { Skeleton } from '@/shadcn/components/Skeleton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const SliderSkeleton = () => {
  return /*#__PURE__*/_jsx("div", {
    className: "w-full",
    children: /*#__PURE__*/_jsx("div", {
      className: "flex overflow-hidden ml-[calc(16px-20px)] 2xl:ml-[calc(50vw-700px+16px-20px)]",
      children: [...Array(3)].map((_, index) => [/*#__PURE__*/_jsxs("div", {
        className: "pl-[20px] md:w-[452px] grow shrink-0",
        children: [/*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx("div", {
            className: "flex aspect-[5/3] text-clip rounded-xl",
            children: /*#__PURE__*/_jsx("div", {
              className: "flex-1",
              children: /*#__PURE__*/_jsx("div", {
                className: "relative size-full origin-bottom transition duration-300 group-hover:scale-105",
                children: /*#__PURE__*/_jsx(Skeleton, {
                  className: "size-full"
                })
              })
            })
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "mb-2 line-clamp-3 break-words pt-4 text-lg font-medium md:mb-3 md:pt-4 md:text-xl lg:pt-4 lg:text-2xl",
          children: [/*#__PURE__*/_jsx(Skeleton, {
            className: "h-6 w-[95%] mb-2"
          }), /*#__PURE__*/_jsx(Skeleton, {
            className: "h-6 w-[250px]"
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "flex items-center text-sm",
          children: /*#__PURE__*/_jsx(Skeleton, {
            className: "h-10 w-[100px]"
          })
        })]
      }, index)])
    })
  });
};

export default SliderSkeleton;